<template>
  <div>
    <!-- 地址弹窗 -->
    <div class="dialogCover" @click.self="closeDialog()" v-if="showMydialog">
      <div class="myDialog">
        <div style="display: flex; justify-content: space-between">
          <span style="font-weight: 600">提货地址</span>
          <i
            class="el-icon-close"
            @click="closeMyDialog()"
            style="cursor: pointer"
          ></i>
        </div>
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
            "
          >
            <div>
              <el-input
                clearable
                @clear="getPeopletable()"
                v-model="nameOrPhone"
                @keyup.native="searchNameOrPhone"
                placeholder="请输入姓名或电话"
                size="medium"
                style="width: 250px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" type="primary">搜索</el-button>
              </el-input>
            </div>

            <el-button
              size="medium"
              plain
              type="primary"
              @click="showAdd(true, 1)"
              >新增地址</el-button
            >
          </div>
          <div
            v-if="edit"
            style="
              background-color: #fff;
              border-radius: 20px;
              padding: 10px;
              box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
              position: relative;
            "
          >
            <el-button
              type="text"
              class="ti_btn"
              @click="showAdd(false)"
              style="color: #000"
              ><i class="el-icon-close"></i
            ></el-button>
            <div style="width: 85%; margin: 0 auto; max-width: 500px">
              <p class="ti_text">
                {{ !this.isBtn ? "修改提货地址" : "新增提货地址" }}
              </p>
              
              <el-form
                :model="submitForm"
                :rules="submitFormRules"
                size="mini"
                ref="submitForm"
                label-width="100px"
              >
                <el-form-item
                  label="联系人"
                  prop="name"
                  style="margin-bottom: 15px"
                >
                  <el-input
                    v-model="submitForm.name"
                    placeholder="请输入联系人"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="联系方式"
                  prop="tel"
                  style="margin-bottom: 15pxpx"
                >
                  <el-input
                    v-model="submitForm.tel"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="联系地址"
                  prop="value"
                  style="margin-bottom: 15px"
                >
                  <el-cascader
                    :options="jackCitylist"
                    placeholder="请选择提货地址"
                    v-model="submitForm.value"
                    clearable
                    @change="handleChange"
                    :props="props"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item
                  label="详细地址"
                  prop="address"
                  style="margin-bottom: 15px"
                >
                  <el-input
                    type="textarea"
                    rows="2"
                    v-model="submitForm.address"
                    placeholder="请输入详细地址"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签" style="margin-bottom: 10px">
                  <el-input
                    v-model="submitForm.tag"
                    placeholder="请输入标签"
                  ></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 16px">
                  <el-checkbox
                    text-color="#FF4D01"
                    v-model="submitForm.isdefault"
                    style="margin-right: 10px"
                  >
                    设置为默认地址</el-checkbox
                  >
                </el-form-item>
                <el-form-item style="margin-bottom: 10px">
                  <el-button
                    @click="addAddr('submitForm')"
                    style="
                      background: #FF4D01;
                      border: 1px solid #FF4D01;
                      border-radius: 5px;
                      color: #fff;
                    "
                    >{{ this.submitForm.id ? "修改" : "新增" }}</el-button
                  >

                  <el-button type="info" @click="showAdd(false)"
                    >关闭</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="messageTag">
            <p>
              该报价只能支持上门取件城市：
              <span>
                {{ whitCityStr || '【暂未维护】' }}
              </span>
              。为避免影响下单，请如实填写上门取件地址。
            </p>
          </div>
          <el-table
            v-if="!edit"
            @row-click="rowClick"
            size="mini"
            height="300"
            tooltip-effect="dark"
            :data="tableData"
            max-height="200"
            highlight-current-row
            border
            ref="Table"
            style="width: 100%; overflow: hidden"
          >
            <el-table-column
              label="姓名"
              width="100"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column label="电话" width="120" align="center" prop="tel">
            </el-table-column>
            <el-table-column
              label="联系地址"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.parvince }}
                {{ scope.row.city }}
                {{ scope.row.area }}
                {{ scope.row.address }}
              </template>
            </el-table-column>
            <el-table-column label="标签" width="120" align="center" prop="tag">
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="setDefault(scope.row)"
                >
                  <span
                    :style="
                      scope.row.isdefault ? 'color:#9A9A9A' : 'color:#FF4D01'
                    "
                    >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
                  >
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="DeleteTitem(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="!edit"
            style="margin-top: 20px"
            title="点击任意一行选择您的地址"
            type="info"
            center
            show-icon
          >
          </el-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showMydialog: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    cityWhiteList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableprops: {
        value: "namec",
        label: "namec",
      },
      props: {
        value: "namec",
        label: "namec",
      },
      jackCitylist: [],
      value: [],
      nameOrPhone: "",
      edit: false,
      submitForm: {
        address: "",
        area: "",
        city: "",
        customerid: 0,
        id: 0,
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
        value: [],
      },
      tableData: [],
      tempTableData: [],
      isBtn: false,
      submitFormRules: {
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        tel: [{ required: true, message: "请输入联系方式", trigger: "blur" },
        { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur'}],
        value: [{ required: true, message: "请输入联系地址", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    LocahouseDTO: function (val) {},
  },
  computed: {
    whitCityStr() {
      if (this.cityWhiteList && this.cityWhiteList.length) {
        const str = this.cityWhiteList.map(v => v.namec).join('、')
        return str
      } else { 
        return ''
      }
    }
  },
  methods: {
    closeMyDialog() {
      if (this.edit) {
        this.$confirm("当前为编辑状态,是否关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$emit("closeExtractlog");
            this.showAdd(false);
          })
          .catch((res) => {});
      } else {
        this.$emit("closeExtractlog");
      }
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];
      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = this.sessionGetUserInfo().customerid;
      this.axios
        .get(`/customer/addressListForFBADelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.tableData = res.data.datas;
            this.tempTableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },
    // 显示新增
    showAdd(type, index) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }
      if (index == 1) {
        this.isBtn = true;
      }

      this.submitForm.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
      console.log("====",this.submitForm)
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info("已经是默认地址");
      }
      this.axios
        .post(`/customer/updateAddressDefault?addressId=${item.id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.getPeopletable();
            this.$message.success("设置成功！");
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
    handleEdit(index, item) {
      this.submitForm.value = [];
      let value = [];
      let temp = JSON.stringify(item);
      this.submitForm = JSON.parse(temp);
      value.push(
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
    
      this.submitForm.value = value;
     
      this.edit = true;
      this.isBtn = false;
    },
    DeleteTitem(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPeopletable();
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info("联系人不能为空！");
        return false;
      }
      if (!this.submitForm.tel) {
        this.$message.info("手机号不能为空！");
        return false;
      }
      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 10) {
          this.$message.info("标签长度不能超过十个字符");
          return false;
        }
      }

      return true;
    },
    addAddr(formName,id) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.submitForm.id) {
            delete this.submitForm.id;
          }
          let user = this.sessionGetUserInfo();
          // 新增
          this.submitForm.customerid = user.customerid;
          let path = "addOrUpdateDelivery";

          this.axios
            .post(`/customer/${path}`, this.submitForm, {})
            .then((res) => {
              if (res.data.code == 200) {
                this.edit = false;
                this.submitForm.value = [];
                this.getPeopletable();
                for (let key in this.submitForm) {
                  this.submitForm[key] = "";
                }
              } else {
                this.$message.info(res.data.message);
              }
            })
            .catch((res) => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 点击行
    rowClick(r) {
      const withCity = this.cityWhiteList.map(v => v.id)
      if (!withCity || !withCity.length) return this.$message.warning('后台暂未维护该报价支持的上门取件城市，请联系客服')
      if (!withCity.includes(r.cityId)) return this.$message.warning('抱歉，您所选的上门取件地址不在支持城市范围内，请重新选择。')
      this.countLIst_T = r;
      sessionStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      this.$emit("closeExtractlog", this.countLIst_T);
      this.$emit("getTimoney", this.countLIst_T);
    },
    handleChange(value) {
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
      this.submitForm.value = value;
    },
    getPopList() {
      // 获取省市区列表
      let user = this.sessionGetUserInfo();
      this.axios
        .post(`/filedata/findDAndILevelAddress`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
  },
  created() {},
  mounted() {
    this.getPeopletable();
    this.getPopList();
  },
};
</script>
<style scoped>
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}

.ti_btn {
  position: absolute;
  right: 20px;
  top: 10px;
}

.ti_text {
  font-size: 16px;
  margin-bottom: 10px;
}
.messageTag {
  display: inline-block;
  width: 100%;
  background-color: #fff6e6;
  color: #ffbf4d;
  border-radius: 5px;
  padding: 12px 18px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/privateOrder/components/takeBill.vue